/**
 * @generated SignedSource<<20ace0f62ada42aab90a07d8415f5a70>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InitiatedBy = "BITPANDA_CORPORATE_ACTION" | "BITPANDA_MANUAL_TRADE" | "BITPANDA_SAVINGS" | "BITPANDA_SWAPS" | "ORDER" | "OTHER" | "USER";
export type LegalClassification = "ARTS" | "EMTS" | "NONE" | "OTHER";
export type TransactionCategory = "CORPORATE_ACTION" | "CRYPTO_ACTION" | "CRYPTO_TRANSFER" | "FIAT_TRANSFER" | "NON_USER_INITIATED" | "STAKING" | "TRADE";
export type TransactionDirection = "INCOMING" | "OUTGOING";
export type TransactionStatus = "CANCELED" | "CREATED" | "CREDITED" | "EXPIRED" | "FAILED" | "FINISHED" | "IN_PROGRESS" | "REFUNDED" | "REJECTED";
export type SwapOfferInput = {
  id: string;
};
export type SwapOfferViewQuery$variables = {
  input?: SwapOfferInput | null | undefined;
};
export type SwapOfferViewQuery$data = {
  readonly swapOffer: {
    readonly __typename: "SwapTransaction";
    readonly category: TransactionCategory;
    readonly childrenTransactions: ReadonlyArray<{
      readonly asset: {
        readonly legalClassification: LegalClassification | null | undefined;
        readonly logoUrl: string | null | undefined;
        readonly name: string | null | undefined;
        readonly symbol: string | null | undefined;
      } | null | undefined;
      readonly assetAmount: PrecisionFloat | null | undefined;
      readonly assetPrice: PrecisionFloat | null | undefined;
      readonly direction: TransactionDirection | null | undefined;
      readonly fiatAmount: PrecisionFloat | null | undefined;
      readonly id: string;
      readonly initiatedBy: InitiatedBy | null | undefined;
      readonly status: TransactionStatus | null | undefined;
      readonly time: TimeScalar | null | undefined;
    }> | null | undefined;
    readonly direction: TransactionDirection | null | undefined;
    readonly feesAfterCost: PrecisionFloat | null | undefined;
    readonly finalRevenueShare: PrecisionFloat | null | undefined;
    readonly id: string;
    readonly initiatedBy: InitiatedBy | null | undefined;
    readonly spread: PrecisionFloat | null | undefined;
    readonly status: TransactionStatus | null | undefined;
    readonly taxAmount: PrecisionFloat | null | undefined;
    readonly time: TimeScalar | null | undefined;
  } | null | undefined;
};
export type SwapOfferViewQuery = {
  response: SwapOfferViewQuery$data;
  variables: SwapOfferViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initiatedBy",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taxAmount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "direction",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feesAfterCost",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalRevenueShare",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spread",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetPrice",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetAmount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legalClassification",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SwapOfferViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SwapTransaction",
        "kind": "LinkedField",
        "name": "swapOffer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "childrenTransactions",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v3/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v19/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SwapOfferViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SwapTransaction",
        "kind": "LinkedField",
        "name": "swapOffer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "childrenTransactions",
            "plural": true,
            "selections": [
              (v19/*: any*/),
              (v2/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v3/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v19/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bbe6011203e7f35b2ed1d1975ae18b9b",
    "id": null,
    "metadata": {},
    "name": "SwapOfferViewQuery",
    "operationKind": "query",
    "text": "query SwapOfferViewQuery(\n  $input: SwapOfferInput\n) {\n  swapOffer(input: $input) {\n    id\n    status\n    time\n    category\n    initiatedBy\n    taxAmount\n    direction\n    feesAfterCost\n    finalRevenueShare\n    spread\n    childrenTransactions {\n      __typename\n      id\n      time\n      initiatedBy\n      direction\n      status\n      assetPrice\n      fiatAmount\n      assetAmount\n      asset {\n        __typename\n        legalClassification\n        logoUrl\n        symbol\n        name\n        id\n      }\n    }\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca59883865943b6552b8ba67790fe5d0";

export default node;
